import * as Yup from 'yup';

export const emailAddressValidation = {
  email: Yup.string().email('Please enter a valid email address.').required('Email address is required')
};

export const confirmPasswordValidation = {
  new_password: Yup.string().min(8, 'Password must be at least 8 characters long').required('Password is required'),
  confirm_password: Yup.string().when('new_password', {
    is: new_password => new_password && new_password.length > 0,
    then: Yup.string()
      .oneOf([Yup.ref('new_password'), null, '', undefined], 'Passwords must match')
      .required('Please confirm your new password.')
  })
};

export const nameValidation = {
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Last name is required')
};

export const phoneValidation = {
  phone: Yup.string().nullable()
};

export const phoneRequiredValidation = {
  phone: Yup.string().required('Phone number is required')
};

export const addressValidation = {
  company: Yup.string().nullable(),
  line1: Yup.string().required('Address is required'),
  line2: Yup.string().nullable(),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  postal_code: Yup.string()
    .required('Postal Code is required')
    .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, 'Must be a valid US Postal Code'),
  country: Yup.string().oneOf(['US', 'us'], 'Country must be U.S.').required('Country is required')
};

export const otpValidation = {
  otp: Yup.string()
    .required('This field is required')
    .matches(/^[0-9]+$/, 'Please enter a valid code')
    .min(6, 'Must be six digits')
    .max(6, 'Must be six digits')
};
